"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
var _ = require('lodash');
var utils = {
  parseToArray: function parseToArray(data) {
    return typeof data === 'string' ? [data] : data;
  },
  parseToTagString: function parseToTagString(data) {
    return data.toUpperCase().split(' ').join('_');
  },
  camelcase: function camelcase(input) {
    var skipMap = {
      NA: 'N/A',
      NOT_OBSERVED: 'N/O',
      SEND_TO_RP: 'Send To RP',
      SENT_TO_RP: 'Sent To RP',
      RESEND_TO_RP: 'Resent To RP'
    };
    input = input || '';
    return skipMap[input] ? skipMap[input] : input.toLowerCase().replace(/_/g, ' ').replace(/^(.)|\s(.)/g, function ($1) {
      return $1.toUpperCase();
    });
  },
  createConfig: function createConfig(obj) {
    var modifiedObj = _.pick(obj, ['BRAND_URL', 'INSPECT_URL', 'NODE_ENV', 'PROFILE_URL', 'RETURN_URL', 'SITE_TITLE', 'SIGN_IN_URL', 'REPORT_PAGE_SIZE', 'RSS_DOMAIN_URL', 'RSS_AUTH_SERVER_URL', 'RSS_AUTH_CLIENT_URL']);
    return modifiedObj;
  },
  getAllowlistUrls: function getAllowlistUrls() {
    return ['ehs.ucop.edu', '*.risksafety.solutions', '*.app.risksafety.solutions', '*.dev.riskandsafety.com', '*.riskandsafety.com', '*.app.riskandsafety.com', '*.amazonaws.com', 'ws://localhost:3001', 'cdn.pendo.io', 'app.pendo.io', 'data.pendo.io', 'cdn.lr-in.com', 'cdn.logrocket.com', '*.storage.googleapis.com', '*.launchdarkly.com', '*.aptrinsic.com', 'google-analytics.com', 'storage.googleapis.com'];
  },
  updatePersonProfile: function updatePersonProfile(data, firstName, lastName, email) {
    data.firstName = firstName;
    data.lastName = lastName;
    data.email = email;
    return data;
  },
  isStale: function isStale(newObject, ObjectInDB) {
    if (newObject.hasOwnProperty('lastModified') && ObjectInDB.hasOwnProperty('lastModified')) {
      return new Date(ObjectInDB.lastModified) > new Date(newObject.lastModified);
    }
    if (!newObject.hasOwnProperty('lastModified') && ObjectInDB.hasOwnProperty('lastModified')) {
      return true;
    }
    return false;
  },
  retry: function () {
    var _retry = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(fn) {
      var retries,
        delay,
        lastError,
        i,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            retries = _args.length > 1 && _args[1] !== undefined ? _args[1] : 3;
            delay = _args.length > 2 && _args[2] !== undefined ? _args[2] : 1000;
            i = 0;
          case 3:
            if (!(i < retries)) {
              _context.next = 19;
              break;
            }
            _context.prev = 4;
            _context.next = 7;
            return fn();
          case 7:
            return _context.abrupt("return", _context.sent);
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            lastError = _context.t0;
            if (!(i < retries - 1)) {
              _context.next = 16;
              break;
            }
            _context.next = 16;
            return new Promise(function (res) {
              return setTimeout(res, delay);
            });
          case 16:
            i++;
            _context.next = 3;
            break;
          case 19:
            throw lastError;
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 10]]);
    }));
    function retry(_x) {
      return _retry.apply(this, arguments);
    }
    return retry;
  }()
};
module.exports = utils;